import React from 'react';
import { Modal } from 'baseui/modal';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { styled, useStyletron } from '../../Themes';
import { MIcon } from '../Icon';
import { dialogHeaderIconStyles, dialogHeaderTextStyles } from './styles';
import { mergeOverrides } from 'baseui';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const { kind = 'neutral', icon = 'chat', unstable_ModalBackdropScroll, overrides, size, layout, ...rest } = props;
	const [css]: any = useStyletron();
	const iconColor: any = {
		info: "var(--epods--color-signal-info-icon)",
		positive: "var(--epods--color-signal-success-icon)",
		warning: "var(--epods--color-signal-warning-icon)",
		negative: "var(--epods--color-signal-error-icon)",
		neutral: "var(--epods--color-text-ds-blue)",
	};
	const _icon: any = {
		negative: "error",
		error: "error",
		positive: "check_circle",
		success: "check_circle",
		warning: "warning",
		info: "info",
		neutral: "chat_bubble",
		default: "chat_bubble"
	}

	const myRef = React.useRef<any>();

	const DialogComponent = () => {
		return (
			<div>
				<Modal
					{...rest}
					size={layout}
					ref={ref}
					overrides={
						overrides
							? mergeOverrides(customOverrides(props), overrides as any)
							: customOverrides(props)
					}
					unstable_ModalBackdropScroll={true}
					mountNode={myRef.current}
				>
					{!props.hideHeader && (
						<DialogHeader>
							{props.icon && (
								<div className={css(dialogHeaderIconStyles(size))}>
									{icon && typeof icon == 'string' ? (
										<MIcon
											icon={icon}
											size={'var(--epods--dialog-header-icon-size)'}
											color={iconColor[kind]}
										/>
									) : (
										icon
									)}
									{!icon && <MIcon
										icon={_icon[kind]}
										size={'var(--epods--dialog-header-icon-size)'}
										color={iconColor[kind]}
									/>}
								</div>
							)}
							<div className={css(dialogHeaderTextStyles(props))}>{props.header}</div>
						</DialogHeader>
					)}
					{props.children}
				</Modal>
			</div>
		);
	};
	return (
		<>
			<DialogComponent />
			<span ref={myRef}></span>
		</>
	);
});

const DialogHeader = styled('div', ({ $theme }: any) => {
	return {
		display: 'flex',
		alignItems: 'center',
		marginBottom: 'var(--epods--space-inset-s2)',
	};
});

export const DialogFooter = styled('div', ({ $theme }: any) => {
	return {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		marginTop: 'var(--epods--dialog-footer-margin)',
		width: '100%',
	};
});
